var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaMarkCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12.5C4.3375 12.5 3.9845 12.3533 3.691 12.0597C3.397 11.7657 3.25 11.4125 3.25 11V2C3.25 1.5875 3.397 1.23425 3.691 0.94025C3.9845 0.64675 4.3375 0.5 4.75 0.5H11.5C11.9125 0.5 12.2657 0.64675 12.5597 0.94025C12.8533 1.23425 13 1.5875 13 2V11C13 11.4125 12.8533 11.7657 12.5597 12.0597C12.2657 12.3533 11.9125 12.5 11.5 12.5H4.75ZM4.75 11H11.5V2H4.75V11ZM1.75 15.5C1.3375 15.5 0.98425 15.3533 0.69025 15.0597C0.39675 14.7657 0.25 14.4125 0.25 14V4.25C0.25 4.0375 0.322 3.85925 0.466 3.71525C0.6095 3.57175 0.7875 3.5 1 3.5C1.2125 3.5 1.39075 3.57175 1.53475 3.71525C1.67825 3.85925 1.75 4.0375 1.75 4.25V14H9.25C9.4625 14 9.64075 14.072 9.78475 14.216C9.92825 14.3595 10 14.5375 10 14.75C10 14.9625 9.92825 15.1405 9.78475 15.284C9.64075 15.428 9.4625 15.5 9.25 15.5H1.75Z",
    fill: "#E32970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMarkCopy);
export default __webpack_public_path__ + "static/media/meta-mark-copy.e8b5131cf92ae52132018b563f2d284d.svg";
export { ForwardRef as ReactComponent };